/* eslint-disable quote-props */

import { h } from 'vue';
import { notification } from 'ant-design-vue';
import CloseCircleOutlined from '@ant-design/icons-vue/CloseCircleOutlined';
import InfoCircleOutlined from '@ant-design/icons-vue/InfoCircleOutlined';
import axios from 'axios';
import RouterConfig from './router-config';
import FingerprintJS from './FingerprintJS';

axios.defaults.baseURL = '/api';

export {
    axios,
    RouterConfig,
    FingerprintJS,
};

export { default as sseService } from './sse';

export const showErrorNotification = (msg, duration = 0) => {
    const key = `open${Date.now()}`;

    notification.open({
        message: 'Ошибка',
        description: msg,
        icon: h(CloseCircleOutlined, { style: { color: '#f5222d' } }),
        key,
        duration: duration ? duration / 1000 : 0, // Ant Design Vue ожидает время в секундах
    });
};

export const showMessageNotification = (msg, duration = 0) => {
    const key = `open${Date.now()}`;

    const handleClick = (event) => {
        event.preventDefault();
        let routerInstance;
        try {
            // Отложенный require, чтобы избежать циклического импорта
            // eslint-disable-next-line global-require
            const routerModule = require('@/router');
            routerInstance = routerModule.default || routerModule;
        } catch (error) {
            // fallback ниже
        }

        if (routerInstance?.push) {
            routerInstance.push({ path: '/notifications' }).catch(() => {});
        } else {
            window.location.assign('/notifications');
        }
        notification.close(key);
    };

    notification.open({
        message: 'Уведомление',
        description: msg,
        icon: h(InfoCircleOutlined, { style: { color: '#1890ff' } }),
        btn: h(
            'a',
            {
                href: '/notifications',
                style: { display: 'inline-block', marginTop: '8px' },
                onClick: handleClick,
            },
            'Все уведомления',
        ),
        key,
        duration: duration ? duration / 1000 : 0, // Ant Design Vue ожидает время в секундах
    });
};

export const showNotification = (title, msg) => {
    notification.open({
        message: title,
        duration: 0,
        description: msg,
        icon: h(CloseCircleOutlined, { style: { color: '#f5222d' } }),
    });
};

export const debounce = ({ ms = 300, callbackFn }) => {
    if (!callbackFn) {
        throw new Error('No callback function provided.');
    }
    let timerId;
    return {
        start: (input) => {
            if (timerId) {
                clearTimeout(timerId);
            }
            timerId = setTimeout(() => {
                timerId = undefined;
                callbackFn(input);
            }, ms);
        },

        stop: () => {
            if (timerId) {
                clearTimeout(timerId);
            }
            timerId = undefined;
        },
    };
};

const layoutMapping = {
    'q': 'й',
    'w': 'ц',
    'e': 'у',
    'r': 'к',
    't': 'е',
    'y': 'н',
    'u': 'г',
    'i': 'ш',
    'o': 'щ',
    'p': 'з',
    '[': 'х',
    ']': 'ъ',
    'a': 'ф',
    's': 'ы',
    'd': 'в',
    'f': 'а',
    'g': 'п',
    'h': 'р',
    'j': 'о',
    'k': 'л',
    'l': 'д',
    ';': 'ж',
    '\'': 'э',
    'z': 'я',
    'x': 'ч',
    'c': 'с',
    'v': 'м',
    'b': 'и',
    'n': 'т',
    'm': 'ь',
    ',': 'б',
    '.': 'ю',
    '/': '.',
    '`': 'ё',
    'Q': 'Й',
    'W': 'Ц',
    'E': 'У',
    'R': 'К',
    'T': 'Е',
    'Y': 'Н',
    'U': 'Г',
    'I': 'Ш',
    'O': 'Щ',
    'P': 'З',
    '{': 'Х',
    '}': 'Ъ',
    'A': 'Ф',
    'S': 'Ы',
    'D': 'В',
    'F': 'А',
    'G': 'П',
    'H': 'Р',
    'J': 'О',
    'K': 'Л',
    'L': 'Д',
    ':': '^',
    '"': 'Э',
    '|': '/',
    'Z': 'Я',
    'X': 'Ч',
    'C': 'С',
    'V': 'М',
    'B': 'И',
    'N': 'Т',
    'M': 'Ь',
    '<': 'Б',
    '>': 'Ю',
    '?': ',',
    '~': 'Ё',
    '@': '"',
    '#': '№',
    '$': ';',
    '^': ':',
    '&': '?',
    'й': 'q',
    'ц': 'w',
    'у': 'e',
    'к': 'r',
    'е': 't',
    'н': 'y',
    'г': 'u',
    'ш': 'i',
    'щ': 'o',
    'з': 'p',
    'х': '[',
    'ъ': ']',
    'ф': 'a',
    'ы': 's',
    'в': 'd',
    'а': 'f',
    'п': 'g',
    'р': 'h',
    'о': 'j',
    'л': 'k',
    'д': 'l',
    'ж': ';',
    'э': '\'',
    'я': 'z',
    'ч': 'x',
    'с': 'c',
    'м': 'v',
    'и': 'b',
    'т': 'n',
    'ь': 'm',
    'б': ',',
    'ю': '.',
    'ё': '`',
    'Й': 'Q',
    'Ц': 'W',
    'У': 'E',
    'К': 'R',
    'Е': 'T',
    'Н': 'Y',
    'Г': 'U',
    'Ш': 'I',
    'Щ': 'O',
    'З': 'P',
    'Х': '{',
    'Ъ': '}',
    'Ф': 'A',
    'Ы': 'S',
    'В': 'D',
    'А': 'F',
    'П': 'G',
    'Р': 'H',
    'О': 'J',
    'Л': 'K',
    'Д': 'L',
    'Ж': ':',
    'Э': '"',
    'Я': 'Z',
    'Ч': 'X',
    'С': 'C',
    'М': 'V',
    'И': 'B',
    'Т': 'N',
    'Ь': 'M',
    'Б': '<',
    'Ю': '>',
    'Ё': '~',
    '№': '#',
};

const alphabetMapping = {
    'e': 'е',
    't': 'т',
    'y': 'у',
    'o': 'о',
    'p': 'р',
    'a': 'а',
    'h': 'н',
    'k': 'к',
    'x': 'х',
    'c': 'с',
    'n': 'н',
    'm': 'м',
    'E': 'Е',
    'T': 'Т',
    'Y': 'У',
    'O': 'О',
    'P': 'Р',
    'A': 'А',
    'H': 'Н',
    'K': 'К',
    'X': 'Х',
    'C': 'С',
    'N': 'Н',
    'M': 'М',
    'у': 'y',
    'к': 'k',
    'е': 'e',
    'н': 'n',
    'х': 'x',
    'а': 'a',
    'р': 'p',
    'о': 'o',
    'с': 'c',
    'м': 'm',
    'т': 't',
    'У': 'Y',
    'К': 'K',
    'Е': 'E',
    'Н': 'H',
    'Х': 'X',
    'В': 'B',
    'А': 'A',
    'Р': 'P',
    'О': 'O',
    'С': 'C',
    'М': 'M',
    'Т': 'T',
};

export const convertAlphabet = (str) => {
    if (typeof str !== 'string') {
        return undefined;
    }
    return str.replace(
        /[etyopahkxcnmETYOPAHKXCNMукенхаросмтУКЕНХВАРОСМТ]/g,
        (m) => alphabetMapping[m],
    );
};

export const convertLayout = (str) => {
    if (typeof str !== 'string') {
        return undefined;
    }
    return str.replace(
        /[qwertyuiop[\]asdfghjkl;'zxcvbnm,./`QWERTYUIOP{}ASDFGHJKL:"|ZXCVBNM<>?~@#$^&йцукенгшщзхъфывапролджэячсмитьбюёЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЯЧСМИТЬБЮЁ№]/g,
        (m) => layoutMapping[m],
    );
};

/**
 * Определяет операционную систему пользователя
 * @returns {string|null} Название ОС (например, "Windows", "macOS", "iOS") или null,
 * если не удалось определить
 */
export const detectOS = () => {
    if (typeof navigator === 'undefined') {
        return null;
    }

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows
    if (userAgent.includes('Windows')) {
        return 'Windows';
    }

    // iOS (проверяем до macOS, т.к. старые iOS-устройства могут содержать "Mac OS X")
    if (/iPad|iPhone|iPod/.test(userAgent)) {
        return 'iOS';
    }

    // macOS
    if (userAgent.includes('Mac OS X') || userAgent.includes('Macintosh')) {
        return 'macOS';
    }

    // Android (проверяем до Linux, т.к. Android-based UA содержат "Linux")
    if (userAgent.includes('Android')) {
        return 'Android';
    }

    // Linux
    if (userAgent.includes('Linux')) {
        return 'Linux';
    }

    // Unix
    if (userAgent.includes('X11')) {
        return 'Unix';
    }

    return null;
};

/**
 * Определяет браузер пользователя
 * @returns {string|null} Название браузера с версией (например, "Chrome 140.0.0")
 * или без версии (например, "Chrome"), или null если не удалось определить
 */
export const detectBrowser = () => {
    if (typeof navigator === 'undefined') {
        return null;
    }

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Chrome (должен проверяться до Edge, так как Edge содержит "Chrome" в userAgent)
    if (userAgent.includes('Edg/')) {
        const match = userAgent.match(/Edg\/(\d+\.\d+\.\d+\.\d+)/);
        if (match) {
            return `Edge ${match[1]}`;
        }
        return 'Edge';
    }

    // Chrome
    if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
        const match = userAgent.match(/Chrome\/(\d+\.\d+\.\d+\.\d+)/);
        if (match) {
            return `Chrome ${match[1]}`;
        }
        return 'Chrome';
    }

    // Firefox
    if (userAgent.includes('Firefox')) {
        const match = userAgent.match(/Firefox\/(\d+\.\d+)/);
        if (match) {
            return `Firefox ${match[1]}`;
        }
        return 'Firefox';
    }

    // Safari (должен проверяться после Chrome, так как Safari содержит "Chrome" в userAgent)
    if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
        const match = userAgent.match(/Version\/(\d+\.\d+)/);
        if (match) {
            return `Safari ${match[1]}`;
        }
        return 'Safari';
    }

    // Opera
    if (userAgent.includes('Opera') || userAgent.includes('OPR/')) {
        const match = userAgent.match(/(?:Opera|OPR)\/(\d+\.\d+)/);
        if (match) {
            return `Opera ${match[1]}`;
        }
        return 'Opera';
    }

    // Internet Explorer
    if (userAgent.includes('MSIE') || userAgent.includes('Trident/')) {
        const match = userAgent.match(/(?:MSIE |rv:)(\d+\.\d+)/);
        if (match) {
            return `Internet Explorer ${match[1]}`;
        }
        return 'Internet Explorer';
    }

    return null;
};

/**
 * Определяет IP-адрес пользователя
 * Использует кэш для быстрого возврата и асинхронный запрос для получения IP
 * @returns {Promise<string|null>} Promise с IP-адресом пользователя или null
 * если не удалось определить
 */
export const detectIP = async () => {
    // Проверяем кэш в sessionStorage (живет только в рамках сессии)
    const cachedIP = sessionStorage.getItem('userIP');
    if (cachedIP) {
        return cachedIP;
    }

    try {
        // Используем популярный сервис для определения IP
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();

        if (data && data.ip) {
            sessionStorage.setItem('userIP', data.ip);
            return data.ip;
        }
    } catch (error) {
        // В случае ошибки пробуем альтернативный сервис
        try {
            const response = await fetch('https://api.ip.sb/ip');
            const ip = await response.text();

            if (ip && ip.trim()) {
                sessionStorage.setItem('userIP', ip.trim());
                return ip.trim();
            }
        } catch (fallbackError) {
            // Игнорируем ошибки, возвращаем null
        }
    }

    // Возвращаем null, если IP не удалось получить
    return null;
};
